import {
  SidebarHeader,
  useSidebar,
} from "@arcadeai/design-system/components/ui/atoms/sidebar";
import { cn } from "@arcadeai/design-system/lib/utils";
import { Link } from "@tanstack/react-router";
import Logo from "@/assets/images/arcade-logo.svg";

export const DashboardSidebarHeader = () => {
  const { open } = useSidebar();
  return (
    <Link to="/">
      <SidebarHeader>
        <div className="relative">
          {/* Show the logo when the sidebar is expanded */}
          <img
            alt="Arcade Logo"
            className={cn(
              "-mb-[0.05rem] h-8 w-auto object-cover px-1 pt-0.5 pb-1.5 invert dark:invert-0",
              open ? "block" : "hidden"
            )}
            height="32"
            src={Logo}
            width="98"
          />
        </div>
        {/* Show the Arcade A letter when the sidebar is collapsed */}
        <div
          className={cn(
            "mb-[0.21rem] flex h-5 w-full items-center justify-center px-1 invert dark:invert-0",
            open ? "hidden" : "block"
          )}
        >
          {/* Use the real favicon.svg when sidebar is collapsed */}
          <svg
            aria-label="logo"
            className="h-full w-full"
            fill="none"
            height="45"
            role="img"
            viewBox="0 0 309 315"
            width="44"
            xmlns="http://www.w3.org/2000/svg"
          >
            <path
              d="M267.074 293.931L266.955 0L231.402 15.9321L45.0407 294.83L9.86791 299.653L0 314.989H98.1906L109.035 299.653L72.3429 293.963L109.535 234.191L171.521 206.478C177.611 203.757 184.212 202.348 190.877 202.348H221.339L221.306 212.98V213.024L221.089 293.974L191.843 298.266L180.705 315H296.993L308.25 298.212M171.293 187.977L125.145 209.176L221.86 60L221.881 86.3042L221.382 158.996L221.339 183.685L190.063 183.652C183.202 183.652 177.514 185.116 171.293 187.977Z"
              fill="white"
            />
            <path
              d="M267.074 293.931L266.955 0L231.402 15.9321L45.0407 294.83L9.86791 299.653L0 314.989H98.1906L109.035 299.653L72.3429 293.963L109.535 234.191L171.521 206.478C177.611 203.757 184.212 202.348 190.877 202.348H221.339L221.306 212.98V213.024L221.089 293.974L191.843 298.266L180.705 315H296.993L308.25 298.212M171.293 187.977L125.145 209.176L221.86 60L221.881 86.3042L221.382 158.996L221.339 183.685L190.063 183.652C183.202 183.652 177.514 185.116 171.293 187.977Z"
              fill="white"
            />
          </svg>
        </div>
      </SidebarHeader>
    </Link>
  );
};
